import Alert from '@/components/elements/notifications/Alert/Alert';
import Icon from '@/components/icons/Icon';
import { _t } from '@/locale';
import ServiceItem from '../components/ServiceItem';
import { SelectAddOnsProps } from './SelectAddOns.types';

/**
 * Presentational recommended-add-ons list; renders booking-selection's ServiceItem
 * rows. Data derivation + gating live in useSelectAddOns.
 */
// No inline padding of its own — the page's content box owns it.
const SelectAddOns = ({
  services,
  onPickService,
  onShowServiceInfo,
  onHideServiceInfo,
  onOpenServiceInfo,
}: SelectAddOnsProps) => {
  // The step's entry gate (steps.ts) needs at least one recommendation, so an empty list here
  // means the user consumed the last one while standing on /tillval and the REMAIN condition
  // is holding them on the step — hence the "all of them are added" copy rather than a blank
  // content area.
  if (!services.length) {
    return (
      <Alert
        variant="information"
        className="p-md"
        leftSlot={<Icon variant="info-circle" size="sm" color="information-900" />}
        body={_t('features.bookingSelection.SelectAddOns.allAddOnsAdded')}
      />
    );
  }
  return (
    <ul className="gap-sm flex flex-col">
      {services.map((service) => (
        <ServiceItem
          key={service.id}
          service={service}
          onPickService={onPickService}
          onShowServiceInfo={onShowServiceInfo}
          onHideServiceInfo={onHideServiceInfo}
          onOpenServiceInfo={onOpenServiceInfo}
          ctaVariant="secondary"
        />
      ))}
    </ul>
  );
};

export default SelectAddOns;
